import { useMemo } from 'react'

import { y } from '@circlefin/form'
import { L3OnboardingPartyType } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import { L3OnboardingDropdown } from '../../L3OnboardingDropdown'

import type { L3OnboardingDropdownVariantProps } from '../types'
import type { SelectListItem } from '@circlefin/components/lib/SelectList'

export const partyTypeSchema = y.mixed<L3OnboardingPartyType>()

export type PartyTypeProps = L3OnboardingDropdownVariantProps & {
  /**
   * Label.
   */
  label?: string
  /**
   * Override default key used to label options.
   */
  optionsKey?: string
}

export const PartyType: React.FC<PartyTypeProps> = ({
  label,
  optionsKey,
  ...props
}) => {
  const { t } = useTranslation('l3Onboarding')

  const data: Array<SelectListItem<L3OnboardingPartyType>> = useMemo(
    () =>
      Object.values(L3OnboardingPartyType).map((option) => ({
        label: t(
          `${optionsKey ?? 'forms.common.partyType'}.options.${
            L3OnboardingPartyType[option]
          }`,
        ),
        value: L3OnboardingPartyType[option],
      })) ?? [],
    [t, optionsKey],
  )

  return (
    <L3OnboardingDropdown
      items={data}
      label={label ?? t`forms.common.partyType.label`}
      {...props}
    />
  )
}
